import { render, staticRenderFns } from "./topFiveEquipmentFailures.vue?vue&type=template&id=2262b1a0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./topFiveEquipmentFailures.vue?vue&type=style&index=0&id=2262b1a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262b1a0",
  null
  
)

export default component.exports